<template>
  <div class="host">
    <slot name="activator" :on="on"></slot>
    <transition name="down-fade">
      <div v-if="show" class="vm-menu" v-click-outside="off" @click="off">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
import ClickOutside from '@app/directives/click-outside.directive';

export default {
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  directives: {
    ClickOutside
  },
  data: () => ({
    show: false
  }),
  methods: {
    on() {
      this.show = true;
    },
    off(e) {
      this.show = false;
    }
  }
};
</script>

<style scoped>
.host {
  position: relative;
}
.vm-menu {
  position: absolute;
  background-color: #fff;
  top: 100%;
  left: 0;
  margin-top: 0;
  border-radius: 3px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.down-fade-enter-active {
  transition: all 200ms ease;
}
.down-fade-leave-active {
  transition: all 200ms ease;
}
.down-fade-enter,
.down-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
